import * as Types from '../../gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResendTwoFactorCodeMutationVariables = Types.Exact<{
  signInInput: Types.SignInFrontendInput;
}>;


export type ResendTwoFactorCodeMutation = { __typename?: 'Mutation', resendTwoFactorCode: { __typename?: 'BooleanhDoeEArX', object?: boolean | null } };

export type SendTwoFactorCodeMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SendTwoFactorCodeMutation = { __typename?: 'Mutation', sendTwoFactorCode: { __typename?: 'Boolean9py5zvTH', object?: boolean | null } };

export type VerifyTwoFactorCodeMutationVariables = Types.Exact<{
  value: Types.Scalars['String'];
}>;


export type VerifyTwoFactorCodeMutation = { __typename?: 'Mutation', verifyTwoFactorCode: { __typename?: 'BooleanOlyZ3SvF', object?: boolean | null, error?: { __typename?: 'BooleanOlyZ3SvFErrorObject', code?: string | null, message: string } | null } };

export type SwitchOrgAsAdministratorMutationVariables = Types.Exact<{
  switchOrgAsAdministratorInput: Types.SwitchOrgAsAdministratorInput;
}>;


export type SwitchOrgAsAdministratorMutation = { __typename?: 'Mutation', switchOrgAsAdministrator: { __typename?: 'AccessTokenResponseObject', object?: { __typename?: 'AccessTokenObject', role?: Types.UserRoles | null, permissions?: Array<Types.UserPermissions> | null, locale?: Types.Locales | null } | null, error?: { __typename?: 'AccessTokenResponseObjectErrorObject', code?: Types.AccessTokenError | null } | null } };

export type ResetPasswordMutationVariables = Types.Exact<{
  resetPasswordInput: Types.ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'AccessTokenObjectUTxbORHC', object?: { __typename?: 'AccessTokenObject', role?: Types.UserRoles | null, permissions?: Array<Types.UserPermissions> | null } | null, error?: { __typename?: 'AccessTokenObjectUTxbORHCErrorObject', code?: Types.AccessTokenError | null } | null } };

export type EditPasswordMutationVariables = Types.Exact<{
  editPasswordInput: Types.EditPasswordInput;
}>;


export type EditPasswordMutation = { __typename?: 'Mutation', editPassword: { __typename?: 'UserObjectILCoFDYS', object?: { __typename?: 'UserObject', id: string } | null, error?: { __typename?: 'UserObjectILCoFDYSErrorObject', code?: string | null } | null } };

export type ActiveTwoFactorAuthMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ActiveTwoFactorAuthMutation = { __typename?: 'Mutation', activeTwoFactorAuth: { __typename?: 'BooleanamoIjOdA', object?: boolean | null, error?: { __typename?: 'BooleanamoIjOdAErrorObject', code?: string | null } | null } };

export type DeactiveTwoFactorAuthMutationVariables = Types.Exact<{
  param: Types.DeactiveTwoFactorAuthInput;
}>;


export type DeactiveTwoFactorAuthMutation = { __typename?: 'Mutation', deactiveTwoFactorAuth: { __typename?: 'BooleanakSV1MHV', object?: boolean | null, error?: { __typename?: 'BooleanakSV1MHVErrorObject', code?: string | null } | null } };

export type SetUserCurrentOrganizationMutationVariables = Types.Exact<{
  organizationId: Types.Scalars['String'];
}>;


export type SetUserCurrentOrganizationMutation = { __typename?: 'Mutation', setUserCurrentOrganization: { __typename?: 'AccessTokenObjectLfaAFVft', error?: { __typename?: 'AccessTokenObjectLfaAFVftErrorObject', code?: Types.AccessTokenError | null } | null } };

export type GetStripeCustomAccountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStripeCustomAccountQuery = { __typename?: 'Query', getStripeCustomAccount: { __typename?: 'StripeAccountResponseObject', object?: { __typename?: 'StripeAccountObject', id: string, country: string, email?: string | null, type?: string | null, payoutInterval: Types.PayoutInterval, isBankConnected: boolean, hasAtLeastOnePayout?: boolean | null, hasOnlyOnePayout?: boolean | null, isRejectedByZeffy?: boolean | null, isRejectedByStripe?: boolean | null, requirements?: { __typename?: 'StripeRequirements', currently_due?: Array<string> | null, current_deadline?: number | null, pending_verification?: Array<string> | null } | null, future_requirements?: { __typename?: 'StripeRequirements', currently_due?: Array<string> | null, current_deadline?: number | null } | null, capabilities: { __typename?: 'StripeCapabilities', transfers?: Types.StripeCapabilityStatus | null, card_issuing?: Types.StripeCapabilityStatus | null }, lastPayout?: { __typename?: 'PayoutObject', id: string, status: Types.StripePayoutStatus, failureMessage?: string | null, failureCode?: string | null, externalAccount: { __typename?: 'ExternalAccountObject', id: string } } | null, externalAccount?: { __typename?: 'ExternalAccountObject', id: string, accountName?: string | null, routingNumber?: string | null, last4?: string | null, currency?: Types.AvailablePaymentCurrency | null, status?: Types.BankAccountStatus | null, bankName?: string | null, country?: Types.CountryCode | null } | null } | null } };

export type MergeUsersMutationVariables = Types.Exact<{
  oldEmail: Types.Scalars['String'];
  newEmail: Types.Scalars['String'];
  encryptedToken: Types.Scalars['String'];
}>;


export type MergeUsersMutation = { __typename?: 'Mutation', mergeUsers: { __typename?: 'MergeUsersObjecth1gQBKxA', object?: { __typename?: 'MergeUsersObject', role?: Types.UserRoles | null } | null, error?: { __typename?: 'MergeUsersObjecth1gQBKxAErrorObject', code?: Types.MergeUsersError | null } | null } };


export const ResendTwoFactorCodeDocument = gql`
    mutation resendTwoFactorCode($signInInput: SignInFrontendInput!) {
  resendTwoFactorCode(signInInput: $signInInput) {
    object
  }
}
    `;
export type ResendTwoFactorCodeMutationFn = Apollo.MutationFunction<ResendTwoFactorCodeMutation, ResendTwoFactorCodeMutationVariables>;

/**
 * __useResendTwoFactorCodeMutation__
 *
 * To run a mutation, you first call `useResendTwoFactorCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendTwoFactorCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendTwoFactorCodeMutation, { data, loading, error }] = useResendTwoFactorCodeMutation({
 *   variables: {
 *      signInInput: // value for 'signInInput'
 *   },
 * });
 */
export function useResendTwoFactorCodeMutation(baseOptions?: Apollo.MutationHookOptions<ResendTwoFactorCodeMutation, ResendTwoFactorCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendTwoFactorCodeMutation, ResendTwoFactorCodeMutationVariables>(ResendTwoFactorCodeDocument, options);
      }
export type ResendTwoFactorCodeMutationHookResult = ReturnType<typeof useResendTwoFactorCodeMutation>;
export type ResendTwoFactorCodeMutationResult = Apollo.MutationResult<ResendTwoFactorCodeMutation>;
export type ResendTwoFactorCodeMutationOptions = Apollo.BaseMutationOptions<ResendTwoFactorCodeMutation, ResendTwoFactorCodeMutationVariables>;
export const SendTwoFactorCodeDocument = gql`
    mutation sendTwoFactorCode {
  sendTwoFactorCode {
    object
  }
}
    `;
export type SendTwoFactorCodeMutationFn = Apollo.MutationFunction<SendTwoFactorCodeMutation, SendTwoFactorCodeMutationVariables>;

/**
 * __useSendTwoFactorCodeMutation__
 *
 * To run a mutation, you first call `useSendTwoFactorCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTwoFactorCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTwoFactorCodeMutation, { data, loading, error }] = useSendTwoFactorCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendTwoFactorCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendTwoFactorCodeMutation, SendTwoFactorCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTwoFactorCodeMutation, SendTwoFactorCodeMutationVariables>(SendTwoFactorCodeDocument, options);
      }
export type SendTwoFactorCodeMutationHookResult = ReturnType<typeof useSendTwoFactorCodeMutation>;
export type SendTwoFactorCodeMutationResult = Apollo.MutationResult<SendTwoFactorCodeMutation>;
export type SendTwoFactorCodeMutationOptions = Apollo.BaseMutationOptions<SendTwoFactorCodeMutation, SendTwoFactorCodeMutationVariables>;
export const VerifyTwoFactorCodeDocument = gql`
    mutation verifyTwoFactorCode($value: String!) {
  verifyTwoFactorCode(value: $value) {
    object
    error {
      code
      message
    }
  }
}
    `;
export type VerifyTwoFactorCodeMutationFn = Apollo.MutationFunction<VerifyTwoFactorCodeMutation, VerifyTwoFactorCodeMutationVariables>;

/**
 * __useVerifyTwoFactorCodeMutation__
 *
 * To run a mutation, you first call `useVerifyTwoFactorCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTwoFactorCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTwoFactorCodeMutation, { data, loading, error }] = useVerifyTwoFactorCodeMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useVerifyTwoFactorCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTwoFactorCodeMutation, VerifyTwoFactorCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyTwoFactorCodeMutation, VerifyTwoFactorCodeMutationVariables>(VerifyTwoFactorCodeDocument, options);
      }
export type VerifyTwoFactorCodeMutationHookResult = ReturnType<typeof useVerifyTwoFactorCodeMutation>;
export type VerifyTwoFactorCodeMutationResult = Apollo.MutationResult<VerifyTwoFactorCodeMutation>;
export type VerifyTwoFactorCodeMutationOptions = Apollo.BaseMutationOptions<VerifyTwoFactorCodeMutation, VerifyTwoFactorCodeMutationVariables>;
export const SwitchOrgAsAdministratorDocument = gql`
    mutation switchOrgAsAdministrator($switchOrgAsAdministratorInput: SwitchOrgAsAdministratorInput!) {
  switchOrgAsAdministrator(
    switchOrgAsAdministratorInput: $switchOrgAsAdministratorInput
  ) {
    object {
      role
      permissions
      locale
    }
    error {
      code
    }
  }
}
    `;
export type SwitchOrgAsAdministratorMutationFn = Apollo.MutationFunction<SwitchOrgAsAdministratorMutation, SwitchOrgAsAdministratorMutationVariables>;

/**
 * __useSwitchOrgAsAdministratorMutation__
 *
 * To run a mutation, you first call `useSwitchOrgAsAdministratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchOrgAsAdministratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchOrgAsAdministratorMutation, { data, loading, error }] = useSwitchOrgAsAdministratorMutation({
 *   variables: {
 *      switchOrgAsAdministratorInput: // value for 'switchOrgAsAdministratorInput'
 *   },
 * });
 */
export function useSwitchOrgAsAdministratorMutation(baseOptions?: Apollo.MutationHookOptions<SwitchOrgAsAdministratorMutation, SwitchOrgAsAdministratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchOrgAsAdministratorMutation, SwitchOrgAsAdministratorMutationVariables>(SwitchOrgAsAdministratorDocument, options);
      }
export type SwitchOrgAsAdministratorMutationHookResult = ReturnType<typeof useSwitchOrgAsAdministratorMutation>;
export type SwitchOrgAsAdministratorMutationResult = Apollo.MutationResult<SwitchOrgAsAdministratorMutation>;
export type SwitchOrgAsAdministratorMutationOptions = Apollo.BaseMutationOptions<SwitchOrgAsAdministratorMutation, SwitchOrgAsAdministratorMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($resetPasswordInput: ResetPasswordInput!) {
  resetPassword(resetPasswordInput: $resetPasswordInput) {
    object {
      role
      permissions
    }
    error {
      code
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      resetPasswordInput: // value for 'resetPasswordInput'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const EditPasswordDocument = gql`
    mutation editPassword($editPasswordInput: EditPasswordInput!) {
  editPassword(editPasswordInput: $editPasswordInput) {
    object {
      id
    }
    error {
      code
    }
  }
}
    `;
export type EditPasswordMutationFn = Apollo.MutationFunction<EditPasswordMutation, EditPasswordMutationVariables>;

/**
 * __useEditPasswordMutation__
 *
 * To run a mutation, you first call `useEditPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPasswordMutation, { data, loading, error }] = useEditPasswordMutation({
 *   variables: {
 *      editPasswordInput: // value for 'editPasswordInput'
 *   },
 * });
 */
export function useEditPasswordMutation(baseOptions?: Apollo.MutationHookOptions<EditPasswordMutation, EditPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPasswordMutation, EditPasswordMutationVariables>(EditPasswordDocument, options);
      }
export type EditPasswordMutationHookResult = ReturnType<typeof useEditPasswordMutation>;
export type EditPasswordMutationResult = Apollo.MutationResult<EditPasswordMutation>;
export type EditPasswordMutationOptions = Apollo.BaseMutationOptions<EditPasswordMutation, EditPasswordMutationVariables>;
export const ActiveTwoFactorAuthDocument = gql`
    mutation activeTwoFactorAuth {
  activeTwoFactorAuth {
    object
    error {
      code
    }
  }
}
    `;
export type ActiveTwoFactorAuthMutationFn = Apollo.MutationFunction<ActiveTwoFactorAuthMutation, ActiveTwoFactorAuthMutationVariables>;

/**
 * __useActiveTwoFactorAuthMutation__
 *
 * To run a mutation, you first call `useActiveTwoFactorAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActiveTwoFactorAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activeTwoFactorAuthMutation, { data, loading, error }] = useActiveTwoFactorAuthMutation({
 *   variables: {
 *   },
 * });
 */
export function useActiveTwoFactorAuthMutation(baseOptions?: Apollo.MutationHookOptions<ActiveTwoFactorAuthMutation, ActiveTwoFactorAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActiveTwoFactorAuthMutation, ActiveTwoFactorAuthMutationVariables>(ActiveTwoFactorAuthDocument, options);
      }
export type ActiveTwoFactorAuthMutationHookResult = ReturnType<typeof useActiveTwoFactorAuthMutation>;
export type ActiveTwoFactorAuthMutationResult = Apollo.MutationResult<ActiveTwoFactorAuthMutation>;
export type ActiveTwoFactorAuthMutationOptions = Apollo.BaseMutationOptions<ActiveTwoFactorAuthMutation, ActiveTwoFactorAuthMutationVariables>;
export const DeactiveTwoFactorAuthDocument = gql`
    mutation deactiveTwoFactorAuth($param: DeactiveTwoFactorAuthInput!) {
  deactiveTwoFactorAuth(param: $param) {
    object
    error {
      code
    }
  }
}
    `;
export type DeactiveTwoFactorAuthMutationFn = Apollo.MutationFunction<DeactiveTwoFactorAuthMutation, DeactiveTwoFactorAuthMutationVariables>;

/**
 * __useDeactiveTwoFactorAuthMutation__
 *
 * To run a mutation, you first call `useDeactiveTwoFactorAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactiveTwoFactorAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactiveTwoFactorAuthMutation, { data, loading, error }] = useDeactiveTwoFactorAuthMutation({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useDeactiveTwoFactorAuthMutation(baseOptions?: Apollo.MutationHookOptions<DeactiveTwoFactorAuthMutation, DeactiveTwoFactorAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactiveTwoFactorAuthMutation, DeactiveTwoFactorAuthMutationVariables>(DeactiveTwoFactorAuthDocument, options);
      }
export type DeactiveTwoFactorAuthMutationHookResult = ReturnType<typeof useDeactiveTwoFactorAuthMutation>;
export type DeactiveTwoFactorAuthMutationResult = Apollo.MutationResult<DeactiveTwoFactorAuthMutation>;
export type DeactiveTwoFactorAuthMutationOptions = Apollo.BaseMutationOptions<DeactiveTwoFactorAuthMutation, DeactiveTwoFactorAuthMutationVariables>;
export const SetUserCurrentOrganizationDocument = gql`
    mutation setUserCurrentOrganization($organizationId: String!) {
  setUserCurrentOrganization(organizationId: $organizationId) {
    error {
      code
    }
  }
}
    `;
export type SetUserCurrentOrganizationMutationFn = Apollo.MutationFunction<SetUserCurrentOrganizationMutation, SetUserCurrentOrganizationMutationVariables>;

/**
 * __useSetUserCurrentOrganizationMutation__
 *
 * To run a mutation, you first call `useSetUserCurrentOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserCurrentOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserCurrentOrganizationMutation, { data, loading, error }] = useSetUserCurrentOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSetUserCurrentOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SetUserCurrentOrganizationMutation, SetUserCurrentOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserCurrentOrganizationMutation, SetUserCurrentOrganizationMutationVariables>(SetUserCurrentOrganizationDocument, options);
      }
export type SetUserCurrentOrganizationMutationHookResult = ReturnType<typeof useSetUserCurrentOrganizationMutation>;
export type SetUserCurrentOrganizationMutationResult = Apollo.MutationResult<SetUserCurrentOrganizationMutation>;
export type SetUserCurrentOrganizationMutationOptions = Apollo.BaseMutationOptions<SetUserCurrentOrganizationMutation, SetUserCurrentOrganizationMutationVariables>;
export const GetStripeCustomAccountDocument = gql`
    query getStripeCustomAccount {
  getStripeCustomAccount {
    object {
      id
      country
      email
      type
      payoutInterval
      isBankConnected
      hasAtLeastOnePayout
      hasOnlyOnePayout
      isRejectedByZeffy
      isRejectedByStripe
      requirements {
        currently_due
        current_deadline
        pending_verification
      }
      future_requirements {
        currently_due
        current_deadline
      }
      capabilities {
        transfers
        card_issuing
      }
      lastPayout {
        id
        status
        failureMessage
        failureCode
        externalAccount {
          id
        }
      }
      externalAccount {
        id
        accountName
        routingNumber
        last4
        currency
        status
        bankName
        country
      }
    }
  }
}
    `;

/**
 * __useGetStripeCustomAccountQuery__
 *
 * To run a query within a React component, call `useGetStripeCustomAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeCustomAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeCustomAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripeCustomAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeCustomAccountQuery, GetStripeCustomAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeCustomAccountQuery, GetStripeCustomAccountQueryVariables>(GetStripeCustomAccountDocument, options);
      }
export function useGetStripeCustomAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeCustomAccountQuery, GetStripeCustomAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeCustomAccountQuery, GetStripeCustomAccountQueryVariables>(GetStripeCustomAccountDocument, options);
        }
export type GetStripeCustomAccountQueryHookResult = ReturnType<typeof useGetStripeCustomAccountQuery>;
export type GetStripeCustomAccountLazyQueryHookResult = ReturnType<typeof useGetStripeCustomAccountLazyQuery>;
export type GetStripeCustomAccountQueryResult = Apollo.QueryResult<GetStripeCustomAccountQuery, GetStripeCustomAccountQueryVariables>;
export const MergeUsersDocument = gql`
    mutation mergeUsers($oldEmail: String!, $newEmail: String!, $encryptedToken: String!) {
  mergeUsers(
    oldEmail: $oldEmail
    newEmail: $newEmail
    encryptedToken: $encryptedToken
  ) {
    object {
      role
    }
    error {
      code
    }
  }
}
    `;
export type MergeUsersMutationFn = Apollo.MutationFunction<MergeUsersMutation, MergeUsersMutationVariables>;

/**
 * __useMergeUsersMutation__
 *
 * To run a mutation, you first call `useMergeUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeUsersMutation, { data, loading, error }] = useMergeUsersMutation({
 *   variables: {
 *      oldEmail: // value for 'oldEmail'
 *      newEmail: // value for 'newEmail'
 *      encryptedToken: // value for 'encryptedToken'
 *   },
 * });
 */
export function useMergeUsersMutation(baseOptions?: Apollo.MutationHookOptions<MergeUsersMutation, MergeUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeUsersMutation, MergeUsersMutationVariables>(MergeUsersDocument, options);
      }
export type MergeUsersMutationHookResult = ReturnType<typeof useMergeUsersMutation>;
export type MergeUsersMutationResult = Apollo.MutationResult<MergeUsersMutation>;
export type MergeUsersMutationOptions = Apollo.BaseMutationOptions<MergeUsersMutation, MergeUsersMutationVariables>;